import { render, staticRenderFns } from "./PlantillasCorreo.vue?vue&type=template&id=3c65968a&scoped=true&"
import script from "./PlantillasCorreo.vue?vue&type=script&lang=js&"
export * from "./PlantillasCorreo.vue?vue&type=script&lang=js&"
import style0 from "./PlantillasCorreo.vue?vue&type=style&index=0&id=3c65968a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c65968a",
  null
  
)

export default component.exports